import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import iconClose from "../../assets/images/icon-login.png";
import iconMap from "../../assets/images/timeKeeping/map.svg";
import { FormTimeKeeping } from "../form/formTimeKeeping";
import { RadioControl, SelectControl } from "../form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { isEndTimeGreater } from "../../utils/utils";
import PopUpGoogleMap from "./popupGoogleMap";
import trashIcon from "../../assets/images/projectManagement/trash-2.svg";

const CHECKIN_MODE_OPTIONS = [
  { value: "NORMAL", label: "Chấm công cả ngày" },
  { value: "SHIFT", label: "Chấm công theo ca" },
];

const CHECKIN_SESSION_TYPES = [
  { value: "MORNING", label: "Ca sáng" },
  // { value: "NOON", label: "Ca trưa" },
  { value: "AFTERNOON", label: "Ca chiều" },
  // { value: "EVENING", label: "Ca tối" },
  // { value: "LATE_NIGHT", label: "Ca khuya" },
];

const DEFAULT_SHIFT_MORNING_SESSION = {
  type: "MORNING",
  name: "Ca sáng",
  start: "08:00",
  end: "08:30",
  checkoutStart: "11:30",
  checkoutEnd: "13:00",
};

const DEFAULT_SHIFT_AFTERNOON_SESSION = {
  type: "AFTERNOON",
  name: "Ca chiều",
  start: "13:30",
  end: "14:00",
  checkoutStart: "17:30",
  checkoutEnd: "18:30",
};

const DEFAULT_SHIFT_SESSIONS = [
  DEFAULT_SHIFT_MORNING_SESSION,
  DEFAULT_SHIFT_AFTERNOON_SESSION,
];

const DEFAULT_TIME_KEEPING_VALUES = {
  timeForSale: "08:00",
  lateTimeForSale: "08:30",
  timeForSupport: "08:00",
  lateTimeForSupport: "08:30",
  blockCheckinTime: "",
  checkoutTime: "17:30",
  saturdayCheckoutTime: "12:00",
  checkinMode: "NORMAL",
  checkinSessions: DEFAULT_SHIFT_SESSIONS,
};

const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;

const schema = Yup.object().shape({
  name: Yup.string().required("Vui lòng nhập điểm chấm công"),
  location: Yup.object().shape({
    lat: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .typeError("Vui lòng nhập một số hợp lệ cho tọa độ lat")
      .required("Vui lòng nhập tọa độ lat")
      .min(0, "Tọa độ lat phải lớn hơn hoặc bằng 0")
      .max(90, "Tọa độ lat phải nhỏ hơn hoặc bằng 90"),

    lng: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value,
      )
      .typeError("Vui lòng nhập một số hợp lệ cho tọa độ lng")
      .required("Vui lòng nhập tọa độ lng")
      .min(0, "Tọa độ lng phải lớn hơn hoặc bằng 0")
      .max(180, "Tọa độ lng phải nhỏ hơn hoặc bằng 180"),
  }),
  timeForSale: Yup.string()
    .required("Vui lòng nhập thời gian bắt đầu đúng giờ")
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d)$/,
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
    ),
  lateTimeForSale: Yup.string()
    .required("Vui lòng nhập thời gian kết thúc đúng giờ")
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d)$/,
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
    )
    .test(
      "is-end-greater",
      "Thời gian kết thúc phải lớn hơn thời gian bắt đầu",
      function (value) {
        return isEndTimeGreater(this.parent.timeForSale, value);
      },
    ),
  timeForSupport: Yup.string()
    .required("Vui lòng nhập thời gian bắt đầu đúng giờ")
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d)$/,
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
    ),
  lateTimeForSupport: Yup.string()
    .required("Vui lòng nhập thời gian kết thúc đúng giờ")
    .matches(
      /^([01]\d|2[0-3]):([0-5]\d)$/,
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
    )
    .test(
      "is-end-greater",
      "Thời gian kết thúc phải lớn hơn thời gian bắt đầu",
      function (value) {
        return isEndTimeGreater(this.parent.timeForSupport, value);
      },
    ),
  blockCheckinTime: Yup.string()
    .optional()
    .test(
      "is-valid-time-format",
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
      (value) => {
        if (!value || value.trim() === "") return true;
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
      },
    ),
  checkoutTime: Yup.string()
    .optional()
    .test(
      "is-valid-time-format",
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
      (value) => {
        if (!value || value.trim() === "") return true;
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
      },
    ),
  saturdayCheckoutTime: Yup.string()
    .optional()
    .test(
      "is-valid-time-format",
      "Thời gian không hợp lệ, định dạng phải là HH:mm",
      (value) => {
        if (!value || value.trim() === "") return true;
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
      },
    ),
  status: Yup.number().default(0),
  identifier: Yup.string().required("Vui lòng nhập tên điểm chấm công"),
  checkinMode: Yup.string().oneOf(["NORMAL", "SHIFT"]).default("NORMAL"),
  checkinSessions: Yup.array().optional(),
});

const normalizeShiftSessions = (sessions = []) => {
  const safeSessions = Array.isArray(sessions) ? sessions : [];

  return DEFAULT_SHIFT_SESSIONS.map((defaultSession) => {
    const existed = safeSessions.find(
      (item) => item?.type === defaultSession.type,
    );

    return {
      ...defaultSession,
      name: existed?.name || defaultSession.name,
      start: existed?.start || defaultSession.start,
      end: existed?.end || defaultSession.end,
      checkoutStart: existed?.checkoutStart || defaultSession.checkoutStart,
      checkoutEnd: existed?.checkoutEnd || defaultSession.checkoutEnd,
    };
  });
};

const PopUpTimeKeeping = ({
  isOpen,
  onClose,
  idEdit,
  onSubmit,
  defaultValues,
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...DEFAULT_TIME_KEEPING_VALUES,
      ...defaultValues,
    },
  });

  const [focusStates, setFocusStates] = useState({});
  const [showGGMap, setShowGGMap] = useState(false);
  const [listBssId, setListBssId] = useState([""]);
  const [errorBssId, setErrorBssId] = useState(false);
  const [shiftSessions, setShiftSessions] = useState(DEFAULT_SHIFT_SESSIONS);
  const [errorShiftSessions, setErrorShiftSessions] = useState("");

  const status = [
    { value: 0, label: "Sử dụng" },
    { value: 1, label: "Không sử dụng" },
  ];

  const options = [
    { value: "0", label: "Ảnh" },
    { value: "1", label: "QR code" },
    { value: "2", label: "BSSID" },
  ];

  useEffect(() => {
    if (isOpen) {
      const nextDefaultValues = {
        ...DEFAULT_TIME_KEEPING_VALUES,
        ...defaultValues,
        checkinSessions: defaultValues?.checkinSessions?.length
          ? defaultValues.checkinSessions
          : DEFAULT_SHIFT_SESSIONS,
      };

      reset(nextDefaultValues);
      setShiftSessions(
        normalizeShiftSessions(nextDefaultValues?.checkinSessions),
      );
    }

    if (idEdit) {
      if (defaultValues?.bssId?.length) {
        setListBssId(defaultValues.bssId);
      } else {
        setListBssId([""]);
      }
    } else {
      setListBssId([""]);
    }

    setErrorBssId(false);
    setErrorShiftSessions("");
  }, [isOpen, defaultValues, reset, idEdit]);

  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const onchangeCheckInTypes = (option) => {
    const currentValue = getValues("checkInTypes");

    if (currentValue === option) {
      setValue("checkInTypes", "");
    } else {
      setValue("checkInTypes", option);
    }

    setErrorBssId(false);
  };

  const handleActionStateChange = (option) => {
    setValue("status", option);
  };

  const getSessionLabel = (type) => {
    return (
      CHECKIN_SESSION_TYPES.find((item) => item.value === type)?.label || type
    );
  };

  const onchangeCheckinMode = (option) => {
    setValue("checkinMode", option, { shouldValidate: true });
    setErrorShiftSessions("");

    if (option === "SHIFT") {
      setShiftSessions((prev) => normalizeShiftSessions(prev));
    }
  };

  const addShiftSession = () => {
    const existedTypes = shiftSessions.map((item) => item.type);

    const nextType =
      CHECKIN_SESSION_TYPES.find((item) => !existedTypes.includes(item.value))
        ?.value || "MORNING";

    setShiftSessions([
      ...shiftSessions,
      {
        type: nextType,
        name: getSessionLabel(nextType),
        start: "",
        end: "",
        checkoutStart: "",
        checkoutEnd: "",
      },
    ]);

    setErrorShiftSessions("");
  };

  const updateShiftSession = (index, field, value) => {
    setShiftSessions((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;

        if (field === "type") {
          return {
            ...item,
            type: value,
            name: getSessionLabel(value),
          };
        }

        return {
          ...item,
          [field]: value,
        };
      }),
    );

    setErrorShiftSessions("");
  };

  const deleteShiftSession = (index) => {
    setShiftSessions((prev) => prev.filter((_, i) => i !== index));
    setErrorShiftSessions("");
  };

  const validateShiftSessions = () => {
    const checkinMode = getValues("checkinMode") || "NORMAL";

    if (checkinMode !== "SHIFT") {
      setErrorShiftSessions("");
      return true;
    }

    const normalizedSessions = normalizeShiftSessions(shiftSessions);

    if (normalizedSessions.length !== 2) {
      setErrorShiftSessions("Vui lòng cấu hình đủ 2 ca chấm công");
      return false;
    }

    const types = new Set();

    for (const session of normalizedSessions) {
      const sessionName = session.name || getSessionLabel(session.type);

      if (!session.type) {
        setErrorShiftSessions("Vui lòng chọn loại ca");
        return false;
      }

      if (types.has(session.type)) {
        setErrorShiftSessions(
          `Loại ca ${getSessionLabel(session.type)} bị trùng`,
        );
        return false;
      }

      types.add(session.type);

      if (!timePattern.test(session.start || "")) {
        setErrorShiftSessions(
          `Thời gian bắt đầu checkin của ${sessionName} không hợp lệ`,
        );
        return false;
      }

      if (!timePattern.test(session.end || "")) {
        setErrorShiftSessions(
          `Thời gian kết thúc checkin của ${sessionName} không hợp lệ`,
        );
        return false;
      }

      if (!timePattern.test(session.checkoutStart || "")) {
        setErrorShiftSessions(
          `Giờ checkout của ${sessionName} không hợp lệ`,
        );
        return false;
      }

      if (session.start === session.end) {
        setErrorShiftSessions(
          `Thời gian bắt đầu và kết thúc checkin của ${sessionName} không được bằng nhau`,
        );
        return false;
      }

      // Giờ checkout của ca phải sau giờ kết thúc checkin (không có ca qua ngày)
      if (session.checkoutStart <= session.end) {
        setErrorShiftSessions(
          `Giờ checkout của ${sessionName} phải sau thời gian kết thúc checkin`,
        );
        return false;
      }
    }

    setErrorShiftSessions("");
    return true;
  };

  const submitHandler = (data) => {
    if (Number(getValues("checkInTypes")) === 2) {
      const isValidBssIdList =
        listBssId.every((bssId) => bssId.trim() !== "") &&
        listBssId.some((bssId) => bssId.trim() !== "");

      if (!isValidBssIdList) {
        setErrorBssId(true);
        return;
      }

      data.bssId = listBssId;
    }

    const checkinMode = data?.checkinMode || "NORMAL";

    if (checkinMode === "SHIFT") {
      const validShiftSessions = validateShiftSessions();

      if (!validShiftSessions) {
        return;
      }

      data.checkinSessions = normalizeShiftSessions(shiftSessions).map(
        (item) => ({
          type: item.type,
          name: item.name || getSessionLabel(item.type),
          start: item.start,
          end: item.end,
          checkoutStart: item.checkoutStart,
          checkoutEnd: item.checkoutEnd,
        }),
      );
    } else {
      data.checkinSessions = [];
    }

    data.checkinMode = checkinMode;

    idEdit ? onSubmit(idEdit, data) : onSubmit(data);
  };

  const handleMapClick = (lat, lng, address) => {
    setValue("location.lat", lat);
    setValue("location.lng", lng);
    setValue("name", address);
  };

  const openMap = () => {
    setShowGGMap(true);
  };

  const closeMap = () => {
    setShowGGMap(false);
  };

  const addBssid = () => {
    setListBssId([...listBssId, ""]);
    setErrorBssId(false);
  };

  const updateBssId = (index, newValue) => {
    setListBssId((prevList) =>
      prevList.map((item, i) => (i === index ? newValue : item)),
    );
    setErrorBssId(false);
  };

  const deleteBssId = (index) => {
    setListBssId((prevList) => {
      const next = prevList.filter((_, i) => i !== index);
      return next.length ? next : [""];
    });
    setErrorBssId(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} trapFocus={false}>
      <ModalOverlay />
      <ModalContent maxW={"50%"}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <Flex
            p={{ base: "25px 24px 24px 24px" }}
            pb={{ base: "24px" }}
            alignContent={"center"}
            justifyContent={"space-between"}
            borderBottom={"1px solid var(--color-boder)"}
          >
            <Text
              fontSize={{ base: "18px" }}
              fontWeight={600}
              color="#000"
              lineHeight={"normal"}
            >
              {defaultValues
                ? "Sửa địa điểm chấm công"
                : "Tạo địa điểm chấm công"}
            </Text>
            <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
          </Flex>

          <Flex
            p={{ base: "24px" }}
            flexDirection={"column"}
            justifyContent={"space-between"}
          >
            <Flex flexDirection={"column"} gap={{ base: "12px" }}>
              <Box position={"relative"}>
                <FormTimeKeeping
                  title={"Điểm chấm công"}
                  place={"Nhập địa điểm chấm công"}
                  isIconPlace={true}
                  isIconTime={false}
                  length={"100%"}
                  register={register("name")}
                  errors={errors.name}
                  handleClick={openMap}
                  icon={iconMap}
                  isRequired={true}
                />
              </Box>

              <Flex alignItems={"center"}>
                <FormControl>
                  <FormLabel
                    mb={"6px"}
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    color={
                      focusStates["identifier"]
                        ? "var(--color-option-employee-hover)"
                        : "var(--color-label-employee)"
                    }
                  >
                    Tên điểm chấm công
                    <Text as="span" color="red" ml="2px">
                      *
                    </Text>
                  </FormLabel>
                  <InputGroup
                    mt={"0"}
                    p={{ base: "10px 14px 10px 12px" }}
                    alignItems={"center"}
                    h={"44px"}
                    border={"0.5px solid var(--Line)"}
                    borderRadius={"8px"}
                    _focus={{
                      boxShadow: "none",
                    }}
                  >
                    <Input
                      color="var(--text-color-Subtittle)"
                      fontWeight={500}
                      fontSize={"14px"}
                      border={"none"}
                      p={"0px"}
                      placeholder={"Nhập tên điểm chấm công"}
                      _focus={{
                        boxShadow: "none",
                      }}
                      borderRadius={"0"}
                      h={"24px"}
                      {...register("identifier")}
                      onFocus={() => handleFocus("identifier")}
                      onBlur={() => handleBlur("identifier")}
                    />
                  </InputGroup>
                  {errors.identifier && (
                    <Text fontSize="12px" color="red" lineHeight={"15px"}>
                      {errors.identifier.message}
                    </Text>
                  )}
                </FormControl>
              </Flex>

              <Flex alignItems={"center"} gap={{ base: "8px" }}>
                <FormTimeKeeping
                  title={"Vị trí (lat)"}
                  place={"Tọa độ lat"}
                  isIconPlace={false}
                  isIconTime={false}
                  length={"126px"}
                  register={register("location.lat")}
                  errors={errors.location?.lat}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                  }}
                  isRequired={true}
                />
                <FormTimeKeeping
                  title={"Vị trí (long)"}
                  place={"Tọa độ long"}
                  isIconPlace={false}
                  isIconTime={false}
                  length={"126px"}
                  register={register("location.lng")}
                  errors={errors.location?.lng}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                  }}
                  isRequired={true}
                />
              </Flex>

              <Flex
                flexDirection={"column"}
                gap={"12px"}
                p={"20px 0"}
                borderBottom={"1px solid var(--border-input-employee)"}
              >
                <SelectControl
                  label="Chế độ chấm công"
                  dataOption={CHECKIN_MODE_OPTIONS}
                  placeholder="Chọn chế độ chấm công"
                  selectedMain={watch("checkinMode") || "NORMAL"}
                  onChange={onchangeCheckinMode}
                  onFocus={() => handleFocus("checkinMode")}
                  onBlur={() => handleBlur("checkinMode")}
                  state={focusStates["checkinMode"]}
                  registerProps={register("checkinMode")}
                />
              </Flex>

              {watch("checkinMode") === "SHIFT" && (
                <Box
                  paddingBottom={"10px"}
                  borderBottom={"1px solid var(--border-input-employee)"}
                >
                  <Text
                    fontSize="12px"
                    fontWeight={400}
                    lineHeight={"15px"}
                    mb={"12px"}
                    color={"var(--color-black-label)"}
                  >
                    Cấu hình ca chấm công theo địa điểm
                  </Text>

                  {shiftSessions.map((session, index) => (
                    <Flex
                      key={`${session.type}-${index}`}
                      gap={"8px"}
                      alignItems={"flex-start"}
                      mb={"12px"}
                    >
                      <FormControl w={"130px"}>
                        <FormLabel
                          fontSize="12px"
                          fontWeight={400}
                          color={"var(--color-label-employee)"}
                          mb={"6px"}
                        >
                          Loại ca
                        </FormLabel>

                        <InputGroup
                          mt={"0"}
                          p={{ base: "10px 8px" }}
                          alignItems={"center"}
                          h={"44px"}
                          border={"0.5px solid var(--Line)"}
                          borderRadius={"8px"}
                          bg={"#F7F8FA"}
                        >
                          <Input
                            color="var(--text-color-Subtittle)"
                            fontWeight={500}
                            fontSize={"13px"}
                            border={"none"}
                            p={"0px"}
                            _focus={{
                              boxShadow: "none",
                            }}
                            borderRadius={"0"}
                            h={"24px"}
                            value={
                              session.name || getSessionLabel(session.type)
                            }
                            isReadOnly
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl w={"130px"}>
                        <FormLabel
                          fontSize="12px"
                          fontWeight={400}
                          color={"var(--color-label-employee)"}
                          mb={"6px"}
                        >
                          Bắt đầu checkin
                        </FormLabel>
                        <InputGroup
                          mt={"0"}
                          p={{ base: "10px 8px" }}
                          alignItems={"center"}
                          h={"44px"}
                          border={"0.5px solid var(--Line)"}
                          borderRadius={"8px"}
                        >
                          <Input
                            type="time"
                            color="var(--text-color-Subtittle)"
                            fontWeight={500}
                            fontSize={"13px"}
                            border={"none"}
                            p={"0px"}
                            _focus={{
                              boxShadow: "none",
                            }}
                            borderRadius={"0"}
                            h={"24px"}
                            value={session.start || ""}
                            onChange={(e) =>
                              updateShiftSession(index, "start", e.target.value)
                            }
                          />
                        </InputGroup>
                      </FormControl>

                      <FormControl w={"130px"}>
                        <FormLabel
                          fontSize="12px"
                          fontWeight={400}
                          color={"var(--color-label-employee)"}
                          mb={"6px"}
                        >
                          Kết thúc checkin
                        </FormLabel>
                        <InputGroup
                          mt={"0"}
                          p={{ base: "10px 8px" }}
                          alignItems={"center"}
                          h={"44px"}
                          border={"0.5px solid var(--Line)"}
                          borderRadius={"8px"}
                        >
                          <Input
                            type="time"
                            color="var(--text-color-Subtittle)"
                            fontWeight={500}
                            fontSize={"13px"}
                            border={"none"}
                            p={"0px"}
                            _focus={{
                              boxShadow: "none",
                            }}
                            borderRadius={"0"}
                            h={"24px"}
                            value={session.end || ""}
                            onChange={(e) =>
                              updateShiftSession(index, "end", e.target.value)
                            }
                          />
                        </InputGroup>
                      </FormControl>

                      {/* Chấm công luồng mới: giờ ra của ca (ra trước giờ này = về sớm). Hạn chấm ra = lúc ca sau bắt đầu chấm vào, ca cuối tới 23:00 */}
                      <FormControl w={"130px"}>
                        <FormLabel
                          fontSize="12px"
                          fontWeight={400}
                          color={"var(--color-label-employee)"}
                          mb={"6px"}
                        >
                          Giờ checkout
                        </FormLabel>
                        <InputGroup
                          mt={"0"}
                          p={{ base: "10px 8px" }}
                          alignItems={"center"}
                          h={"44px"}
                          border={"0.5px solid var(--Line)"}
                          borderRadius={"8px"}
                        >
                          <Input
                            type="time"
                            color="var(--text-color-Subtittle)"
                            fontWeight={500}
                            fontSize={"13px"}
                            border={"none"}
                            p={"0px"}
                            _focus={{
                              boxShadow: "none",
                            }}
                            borderRadius={"0"}
                            h={"24px"}
                            value={session.checkoutStart || ""}
                            onChange={(e) =>
                              updateShiftSession(
                                index,
                                "checkoutStart",
                                e.target.value,
                              )
                            }
                          />
                        </InputGroup>
                      </FormControl>

                      {/* Bỏ "Kết thúc checkout" (khách chốt 14/10): không quá hạn chấm ra theo khung, 23:00 job tự kết thúc */}
                      {/*                       <FormControl w={"130px"}>
                        <FormLabel
                          fontSize="12px"
                          fontWeight={400}
                          color={"var(--color-label-employee)"}
                          mb={"6px"}
                        >
                          Kết thúc checkout
                        </FormLabel>
                        <InputGroup
                          mt={"0"}
                          p={{ base: "10px 8px" }}
                          alignItems={"center"}
                          h={"44px"}
                          border={"0.5px solid var(--Line)"}
                          borderRadius={"8px"}
                        >
                          <Input
                            type="time"
                            color="var(--text-color-Subtittle)"
                            fontWeight={500}
                            fontSize={"13px"}
                            border={"none"}
                            p={"0px"}
                            _focus={{
                              boxShadow: "none",
                            }}
                            borderRadius={"0"}
                            h={"24px"}
                            value={session.checkoutEnd || ""}
                            onChange={(e) =>
                              updateShiftSession(
                                index,
                                "checkoutEnd",
                                e.target.value,
                              )
                            }
                          />
                        </InputGroup>
                      </FormControl> */}

                      {/* Tạm ẩn xóa ca */}
                      {/* <Image
                          cursor={"pointer"}
                          src={trashIcon}
                          mt={"32px"}
                          mr={"4px"}
                          onClick={() => deleteShiftSession(index)}
                          _hover={{
                            filter: "var(--filter-red)",
                          }}
                        /> */}
                    </Flex>
                  ))}

                  {errorShiftSessions && (
                    <Text fontSize="12px" color="red" lineHeight={"15px"}>
                      {errorShiftSessions}
                    </Text>
                  )}

                  {/* Tạm ẩn thêm ca */}
                  {/* <Button
                      display="flex"
                      alignItems="center"
                      p="10px 16px"
                      gap="8px"
                      backgroundImage="var(--color-button)"
                      _hover={{
                        filter: "brightness(90%)",
                      }}
                      mt={"12px"}
                      onClick={addShiftSession}
                    >
                      <Text
                        fontSize="15px"
                        fontWeight={600}
                        color="var(--color-main)"
                      >
                        Thêm ca
                      </Text>
                    </Button> */}
                </Box>
              )}

              {watch("checkinMode") === "NORMAL" && (
                <Flex
                  gap={"25px"}
                  p={"0px 0"}
                  // borderTop={"1px solid var(--border-input-employee)"}
                  // borderBottom={"1px solid var(--border-input-employee)"}
                >
                  <Box>
                    <Text
                      fontSize={"14px"}
                      lineHeight={"16.94px"}
                      fontWeight={600}
                      mb={"12px"}
                    >
                      Nhân viên kinh doanh
                    </Text>
                    <Flex gap={"8px"}>
                      <FormTimeKeeping
                        title={"TG đúng giờ"}
                        place={"Từ giờ"}
                        type="time"
                        isIconPlace={false}
                        isIconTime={true}
                        length={"126px"}
                        register={register("timeForSale")}
                        errors={errors.timeForSale}
                        isRequired={true}
                      />
                      <FormTimeKeeping
                        title={"TG muộn giờ"}
                        place={"Đến giờ"}
                        type="time"
                        isIconPlace={false}
                        isIconTime={true}
                        length={"126px"}
                        register={register("lateTimeForSale")}
                        errors={errors.lateTimeForSale}
                        isRequired={true}
                      />
                    </Flex>
                  </Box>

                  <Box>
                    <Text
                      fontSize={"14px"}
                      lineHeight={"16.94px"}
                      fontWeight={600}
                      mb={"12px"}
                    >
                      Nhân viên hỗ trợ kinh doanh
                    </Text>

                    <Flex gap={"8px"}>
                      <FormTimeKeeping
                        title={"TG đúng giờ"}
                        place="Từ giờ"
                        type="time"
                        isIconPlace={false}
                        isIconTime={true}
                        length="126px"
                        register={register("timeForSupport")}
                        errors={errors.timeForSupport}
                        isRequired={true}
                      />
                      <FormTimeKeeping
                        type="time"
                        title={"TG muộn giờ"}
                        place={"Đến giờ"}
                        isIconPlace={false}
                        isIconTime={true}
                        length={"126px"}
                        register={register("lateTimeForSupport")}
                        errors={errors.lateTimeForSupport}
                        isRequired={true}
                      />
                    </Flex>
                  </Box>
                </Flex>
              )}

              {watch("checkinMode") === "NORMAL" && (
                <Flex
                  gap={"25px"}
                  // p={"20px 0"}
                  paddingBottom={"20px"}
                  borderBottom={"1px solid var(--border-input-employee)"}
                >
                  <FormTimeKeeping
                    title={"TG kết thúc"}
                    place={"Đến giờ"}
                    type="time"
                    isIconPlace={false}
                    isIconTime={true}
                    length={"126px"}
                    register={register("blockCheckinTime")}
                    errors={errors.blockCheckinTime}
                  />
                  <FormTimeKeeping
                    title={"Giờ ra"}
                    place={"Giờ ra"}
                    type="time"
                    isIconPlace={false}
                    isIconTime={true}
                    length={"126px"}
                    register={register("checkoutTime")}
                    errors={errors.checkoutTime}
                  />
                  <FormTimeKeeping
                    title={"Giờ ra thứ 7"}
                    place={"Giờ ra"}
                    type="time"
                    isIconPlace={false}
                    isIconTime={true}
                    length={"126px"}
                    register={register("saturdayCheckoutTime")}
                    errors={errors.saturdayCheckoutTime}
                  />
                </Flex>
              )}

              <SelectControl
                label="Yêu cầu thêm"
                dataOption={options}
                placeholder="Chọn thêm yêu cầu"
                selectedMain={watch("checkInTypes")}
                onChange={onchangeCheckInTypes}
                onFocus={() => handleFocus("checkInTypes")}
                onBlur={() => handleBlur("checkInTypes")}
                state={focusStates["checkInTypes"]}
                registerProps={register("checkInTypes")}
              />

              {Number(getValues("checkInTypes")) === 2 && (
                <Box>
                  <Text
                    fontSize="12px"
                    fontWeight={400}
                    lineHeight={"15px"}
                    mb={"12px"}
                    color={"var(--color-black-label)"}
                  >
                    BSSID
                  </Text>

                  {listBssId.map((item, index) => (
                    <Flex
                      key={index}
                      gap={"27px"}
                      alignItems={"center"}
                      mb={"16px"}
                    >
                      <InputGroup
                        mt={"0"}
                        p={{ base: "10px 14px 10px 12px" }}
                        alignItems={"center"}
                        h={"44px"}
                        border={"0.5px solid var(--Line)"}
                        borderRadius={"8px"}
                        _focus={{
                          boxShadow: "none",
                        }}
                      >
                        <Input
                          color="var(--text-color-Subtittle)"
                          fontWeight={500}
                          fontSize={"14px"}
                          border={"none"}
                          p={"0px"}
                          placeholder={"Nhập bssid"}
                          _focus={{
                            boxShadow: "none",
                          }}
                          borderRadius={"0"}
                          h={"24px"}
                          value={item || ""}
                          onChange={(e) => updateBssId(index, e.target.value)}
                          step="any"
                        />
                      </InputGroup>

                      <Image
                        cursor={"pointer"}
                        src={trashIcon}
                        mr={"12px"}
                        onClick={() => deleteBssId(index)}
                        _hover={{
                          filter: "var(--filter-red)",
                        }}
                      />
                    </Flex>
                  ))}

                  {errorBssId && (
                    <Text fontSize="12px" color="red" lineHeight={"15px"}>
                      Vui lòng nhập và không bỏ trống BSSID
                    </Text>
                  )}

                  <Button
                    display="flex"
                    alignItems="center"
                    p="10px 16px"
                    gap="8px"
                    backgroundImage="var(--color-button)"
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                    mt={"12px"}
                    onClick={addBssid}
                  >
                    <Text
                      fontSize="15px"
                      fontWeight={600}
                      color="var(--color-main)"
                    >
                      Thêm BSSID
                    </Text>
                  </Button>
                </Box>
              )}

              <FormLabel
                fontSize={{ base: "12px" }}
                fontWeight={400}
                color={"var(--color-label-employee)"}
                mb={"0px"}
              >
                Trạng thái hoạt động
              </FormLabel>

              <RadioControl
                options={status}
                selectedValue={watch("status")}
                onChange={handleActionStateChange}
              />
            </Flex>

            <Flex justifyContent={"flex-end"} mt={"80px"}>
              <Button
                type="submit"
                color={"#FFF"}
                fontSize={"15px"}
                fontWeight={600}
                lineHeight={"normal"}
                backgroundImage="var(--color-button)"
                _hover={{
                  backgroundImage: "var(--color-button)",
                }}
              >
                {defaultValues ? "Sửa điểm CC" : "Tạo điểm CC"}
              </Button>
            </Flex>
          </Flex>
        </form>
      </ModalContent>

      {showGGMap && (
        <PopUpGoogleMap
          onMapClick={(lat, lng, address) => {
            handleMapClick(lat, lng, address);
          }}
          onClose={closeMap}
          trapFocus={false}
        />
      )}
    </Modal>
  );
};

export default PopUpTimeKeeping;
